import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { SubPayout } from 'anchor-shared/lib/model/entity/subPayout';
import { PayoutDAO } from '../../../../../../core/services/dao/payoutDAO';
import { SubPayoutDAO } from '../../../../../../core/services/dao/subPayoutDAO';

@Component({
  selector: 'app-hold-payouts-modal',
  templateUrl: './hold-payouts-modal.component.html',
  styleUrls: ['./hold-payouts-modal.component.scss'],
})
export class HoldPayoutsModalComponent implements OnInit {
  payouts: Payout[] = [];
  subPayouts: SubPayout[] = [];
  heldPayoutCount: number = 0;
  updatedPayouts: Payout[] = [];
  updatedSubPayouts: SubPayout[] = [];
  charterId: number = null;
  changeHasOccurred: boolean;

  constructor(
    private dialogRef: MatDialogRef<HoldPayoutsModalComponent>,
    private payoutDao: PayoutDAO,
    private subPayoutDao: SubPayoutDAO,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.payouts = JSON.parse(JSON.stringify(data.payouts));
  }

  ngOnInit(): void {
    this.initSubPayouts();
    this.heldPayoutCount = this.countHeldPayouts();
  }

  initSubPayouts(): void {
    this.payouts.forEach((payout) => {
      if (payout.subPayouts && payout.subPayouts.length) {
        this.subPayouts = [...this.subPayouts, ...payout.subPayouts];
      }
    });
  }

  updateHeldCount(
    checked: boolean,
    payout: Payout | SubPayout,
    isSubPayout: boolean,
  ) {
    this.changeHasOccurred = true;
    if (checked) {
      payout.adminHold = true;
      this.heldPayoutCount++;
    } else {
      payout.adminHold = false;
      this.heldPayoutCount--;
    }
    if (isSubPayout) {
      this.updatedSubPayouts.push(payout as SubPayout);
    } else {
      this.updatedPayouts.push(payout as Payout);
    }
  }

  countHeldPayouts(): number {
    let count = 0;
    this.payouts.forEach((payout) => {
      if (payout.subPayouts && payout.subPayouts.length) {
        payout.subPayouts.forEach((subPayout) => {
          if (subPayout.adminHold) {
            count++;
          }
        });
      } else if (payout.adminHold) {
        count++;
      }
    });
    return count;
  }

  holdPayouts() {
    console.log('sub', this.updatedSubPayouts);
    console.log('normal', this.updatedPayouts);
    const normalPayouts: Partial<Payout>[] = this.updatedPayouts.map(
      (payout) => {
        return {
          id: payout.id,
          adminHold: payout.adminHold,
        };
      },
    );
    const subPayouts: Partial<SubPayout>[] = this.updatedSubPayouts.map(
      (subPayout) => {
        return {
          id: subPayout.id,
          adminHold: subPayout.adminHold,
        };
      },
    );
    const updateNormal = this.payoutDao.updateMultiple(
      normalPayouts as Payout[],
    );
    const updateSub = this.subPayoutDao.updateMultiple(subPayouts);

    combineLatest([updateNormal, updateSub]).subscribe(() => {
      console.log('updated');
      this.dialogRef.close({
        updatedSubPayouts: this.updatedSubPayouts,
        updatedPayouts: this.updatedPayouts,
      });
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
